import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CallIcon from "@mui/icons-material/Call";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import EditIcon from "@mui/icons-material/Edit";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import MailIcon from "@mui/icons-material/Mail";
import MedicationIcon from "@mui/icons-material/Medication";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { Card, Container, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import EditIconImg from "../../../assets/images/png/edit2.png";
import PlusIcon from "../../../assets/images/png/plus.png";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import Select from "../../../components/Select/Select";
import api from "../../../redux/actions/api";
import { createNewChat } from "../../../redux/reducers/chatSlice";
import {
  checkedCallInApi,
  checkedInApi,
  clinicReassignAppointment,
  getBillingListByPetId,
  getPetBillingByIdAll,
  updateAppointmentStatusById,
  updateClinicUserById,
  updateCompleted,
  updateFinalize,
  updateHospitalizationStatus,
} from "../../../redux/reducers/clinicSlice";
import { getMedicalHistoryByPetId } from "../../../redux/reducers/medicalHistorySlice";
import {
  addCoOwnerByPetId,
  getPetBreedsByType,
  getPetDetailsById,
  getPetsCompliantSummary,
  getPetTypes,
  updatePetById,
} from "../../../redux/reducers/petSlice";
import {
  assignTreatmentBundleToPet,
  getAllTreatmentBundlesByPetId,
  getTreatmentBundles,
} from "../../../redux/reducers/planSlice";
import {
  getClinicVets,
  updateAppointmentStatus,
} from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { radioPaymentTypes } from "../../../util/arrayList";
import { a4PrintConfig } from "../../../util/commonConfig";
import {
  bloodGroups,
  genderList,
  presFilters,
  reproductiveStatusFemaleList,
  reproductiveStatusMaleList,
  reproductiveStatusUnknownList,
  temperaments,
  UserPaymentTypeList,
} from "../../../util/dropList";
import {
  getBorderColor,
  getMonthsDifference,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getTaxAndSubTotalAndTotal,
  getTotalEstimatedCost,
  getTotalPaidUnpaidForBillings,
  getTreatmentRecordBasedType,
  reduceYearsAndMonthsToStartOfMonth,
} from "../../../util/function";
import { superTailsClinicId } from "../../../util/server";
import CreateClinicPet from "../../CommonComponents/CreateClinicPet";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import ContentToPrint from "../../CommonScreens/ContentToPrint/ContentToPrint";
import MedicalHistoryView from "../../Hospital/ClinicPetDetails/MedicalHistory/MedicalHistoryView";
import Allergies from "../../Hospital/ClinicPetDetails/PatientWorkbook/Allergies";
import InternalNotes from "../../Hospital/ClinicPetDetails/PatientWorkbook/InternalNotes";
import InternalTags from "../../Hospital/ClinicPetDetails/PatientWorkbook/InternalTags";
import Preventive from "../../Hospital/ClinicPetDetails/PatientWorkbook/Preventive";
import InpatientAdmitPatient from "../AdmitPatient/InpatientAdmitPatient";
import BookAnAppointment from "../BookAppointmentment/BookAnAppointment";
import ReminderDiagnostics from "../Reminder/ReminderDiagnostics";
import ReminderPrescription from "../Reminder/ReminderPrescription";
import ReminderPreventive from "../Reminder/ReminderPreventive";
import ReminderProcedure from "../Reminder/ReminderProcedure";
import "./CommonClinicPetDetails.css";

const initCoOwnValues = { name: "", email: "", mobile: "" };
const initCoOwnErrors = { name: false, email: false, mobile: false };
const keysToCheck = [
  "invoiceNumbers",
  "petShopInvoiceNumber",
  "treatmentInvoiceNumber",
];

const requiredFields = [
  "petName",
  "dob",
  "breed",
  // "gender",
  // "reproductiveStatus",
  // "weight",
  "petType",
];
const initSOAValues = {
  visible: false,
  startDate: new Date(),
  endDate: new Date(),
  dateSelected: false,
  endDateErr: false,
};

const CommonClinicPetDetails = ({
  children,
  upcomingVisible,
  setVideoCallEnabled,
  appointment,
  scrollable = true,
  setSelectedTab,
  setInpatientId,
  allergyModOpen,
  setAllergyModOpen,
  selectedTab,
  setScrollable,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const contentToPrint = useRef(null);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [selectPet, setSelectPet] = useState(null);
  const [modalBookVisible, setBookModVisible] = useState(false);
  const [coOwnerModalVisible, setCoOwnerModalVisible] = useState(false);
  const [intrnalTagModVsble, setIntrnalTagModVsble] = useState(false);
  const [intrnalNoteModVsble, setIntrnalNoteModVsble] = useState(false);
  const [admitModVisible, setAdmitModVisible] = useState(false);
  const [vets, setVets] = useState([]);
  const [coOwnDetails, setCoOwnDetails] = useState(initCoOwnValues);
  const [coOwnErrors, setCoOwnErrors] = useState(initCoOwnErrors);
  const [disCofrmModVsble, setDisConfrmModVsble] = useState(false);
  const [createPetModVsble, setCreatePetModVsble] = useState(false);
  const [bundleModVsble, setBundleModVsble] = useState(false);
  const [isAddNewBundle, setAddNewBundle] = useState(false);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [sendToRecovery, setSendToRecovery] = useState(false);
  const [assignVetModVisible, setAssignVetModVisible] = useState(false);
  const [assignVetvalues, setAssignVetValues] = useState({});
  const [bundleSearchValue, setBundleSearchValue] = useState("");
  const [petModVsble, setPetModVsble] = useState(false);
  const [petValues, setPetValues] = useState({});
  const [errors, setErrors] = useState({});
  const [breedList, setBreedList] = useState([]);
  const [petTypeList, setPetTypeList] = useState([]);
  const [usrModVsble, setUsrModVsble] = useState(false);
  const [usrValues, setUsrValues] = useState({});
  const [usrErrs, setUsrErrs] = useState({});
  const [advancePayVsble, setAdvancePayModVsble] = useState(false);
  const [remModVsble, setRemModVsble] = useState(false);
  const [actTab, setActTab] = useState("preventive");
  const [presFilter, setPresFilter] = useState("Active");
  const [addVsble, setAddVsble] = useState(false);
  const [certModVsble, setCertModVsble] = useState(false);
  const [soaValues, setSOAValues] = useState(initSOAValues);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const appData = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petDetails = useSelector((state) => state?.pet?.petDetails);
  const petBilling = useSelector((state) => state?.clinic?.petAllBilling);
  const {
    details: clinicDetails,
    facilities,
    petBillingList,
  } = useSelector((state) => state?.clinic);
  const { treatmentBundles, petTreatmentBundles } = useSelector(
    (state) => state?.plan,
  );
  const apntId = appointment?.appoinment?.appointmentId;
  const petId = appointment?.appoinment?.petId;
  const petData = apntId ? appData?.pet : petDetails;
  const apntDet = appData?.appointment ?? appointment?.appoinment;
  const statusActive =
    typeof petData?.status === "boolean"
      ? petData?.status
      : petData?.status === "Y";
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const role = localStorage.getItem("role");
  const clinicDet = clinicDetails;

  useEffect(() => {
    if (apntId === apntDet?.appointmentId) return;
    if (apntId !== apntDet?.appointmentId) getcompliantSummary(apntId);
  }, [apntId, apntDet?.appointmentId]);

  useEffect(() => {
    if (selectedTab === "overView") {
      if (vets?.length === 0 || !vets) dispatch(getClinicVets("?type=all"));
      dispatch(getPetBillingByIdAll({ petId }));
    }
  }, [selectedTab]);

  useEffect(() => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    setVets(reqVetList);
  }, [clinicVets]);

  const getcompliantSummary = (apntId = null) => {
    const reqApntId = apntId ?? apntDet?.appointmentId;
    dispatch(getPetsCompliantSummary(reqApntId));
  };

  const bookAppointment = () => {
    setSelectPet(petData);
    setBookModVisible(true);
  };

  const openCoOwnerModal = () => {
    setCoOwnerModalVisible(true);
  };

  const openIntrnalTagModal = () => {
    setIntrnalTagModVsble(true);
  };

  const openIntrnalNotModal = () => {
    setIntrnalNoteModVsble(true);
  };

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y")
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType = type === "Grooming" ? "ROLE_GROOMER" : "ROLE_RADIOLOGY";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.userRole === reqType)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getVetList = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const checkIsVet = (apntVetId = null) => {
    if (!apntVetId) return false;
    return clinicVets?.some((li) =>
      li?.doctorId === apntVetId && li?.userType?.length > 0
        ? li?.userType?.some((ut) => ut?.name === "ROLE_DOCTOR")
        : false,
    );
  };

  const onCloseAssignVetMod = () => {
    setAssignVetModVisible(false);
    setAssignVetValues({});
  };

  const handleCallInApi = (
    vetId = null,
    facilityId = null,
    facilityName = null,
  ) => {
    const data = {
      appointmentId: apntDet?.appointmentId,
      doctorId: vetId ?? apntDet?.doctorId,
      facilityId,
      facilityName,
    };
    dispatch(checkedCallInApi(data)).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        getcompliantSummary();
        // const reAssignValues = { facilityId, facilityName, doctorId: vetId };
        // dispatch(
        //   clinicReassignAppointment({
        //     appointmentId: apntDet?.appointmentId,
        //     data: reAssignValues,
        //   }),
        // )?.then((apiRes) => {
        //   if (apiRes?.payload) {
        //     onCloseAssignVetMod();
        //     getcompliantSummary();
        //   }
        // });
      }
    });
  };

  const callButtonApi = () => {
    if (apntDet?.appointmentType === "Virtual") {
      return handleJoinVideoCall();
    }
    if (apntDet?.appointmentStatus === "scheduled") {
      const data = {
        appointmentId: apntDet?.appointmentId,
        doctorId: apntDet?.doctorId,
      };
      dispatch(checkedInApi(data)).then((response) => {
        if (response?.payload) {
          getcompliantSummary();
        }
      });
    } else if (apntDet?.appointmentStatus === "inprogress") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        handleCallInApi(
          checkIsVet(profile?.id) ? profile?.id : apntDet?.doctorId,
          apntDet?.facilityId,
          apntDet?.facility,
        );
      }
    } else if (apntDet?.appointmentStatus === "consultation") {
      dispatch(updateFinalize(apntDet?.appointmentId)).then((response) => {
        if (response?.payload) {
          getcompliantSummary();
        }
      });
    } else {
      dispatch(updateCompleted(apntDet?.appointmentId)).then((response) => {
        if (response?.payload) {
          if (
            profile?.createdBy === superTailsClinicId ||
            profile?.id === superTailsClinicId
          ) {
            dispatch(
              getMedicalHistoryByPetId({
                petId: apntDet?.petId,
                // url: `?type=all&page=1&itemSize=5`,
              }),
            ).then((res2) => {
              if (res2?.payload?.data) {
                setSelectedHistory(res2?.payload?.data?.[0]);
              }
            });
          }
          getcompliantSummary();
        }
      });
    }
  };

  const handleInTransitApi = (
    vetId = null,
    facilityId = null,
    facilityName = null,
  ) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status: "intransit",
        successMsg: "Patient has been notified!",
        url: `&facilityId=${facilityId}&facilityName=${facilityName}&doctorId=${vetId}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        getcompliantSummary();
        // const data = { facilityId, facilityName, doctorId: vetId };
        // dispatch(
        //   clinicReassignAppointment({
        //     appointmentId: apntDet?.appointmentId,
        //     data,
        //   })
        // )?.then((apiRes) => {
        //   if (apiRes?.payload) {
        //     onCloseAssignVetMod();
        //     getcompliantSummary();
        //   }
        // });
      }
    });
  };

  const callHomeBtnApi = () => {
    if (apntDet?.appointmentType === "Virtual") {
      return handleJoinVideoCall();
    }
    if (apntDet?.appointmentType === "Physical") {
      return callButtonApi();
    }
    let status = "scheduled";
    if (apntDet?.appointmentStatus === "scheduled") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        handleInTransitApi(
          checkIsVet(profile?.id) ? profile?.id : apntDet?.doctorId,
          apntDet?.facilityId,
          apntDet?.facility,
        );
      }
    }
    if (apntDet?.appointmentStatus === "intransit") {
      status = "consultation";
    }
    if (apntDet?.appointmentStatus === "consultation") {
      status = "finalize";
    }
    if (apntDet?.appointmentStatus === "finalize") {
      status = "completed";
    }
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status,
        successMsg:
          status === "intransit"
            ? "Patient has been notified!"
            : "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        if (
          (status === "completed" &&
            profile?.createdBy === superTailsClinicId) ||
          profile?.id === superTailsClinicId
        ) {
          dispatch(
            getMedicalHistoryByPetId({
              petId: apntDet?.petId,
              // url: `?type=all&page=1&itemSize=5`,
            }),
          ).then((res2) => {
            if (res2?.payload?.data) {
              setSelectedHistory(res2?.payload?.data?.[0]);
            }
          });
        }
        if (clinicDetails?.id !== apntDet?.doctorId) {
          getcompliantSummary(apntDet?.appointmentId);
        }
      }
    });
  };

  const handleJoinVideoCall = () => {
    setVideoCallEnabled(true);
    if (navigator.mediaDevices.getUserMedia !== null) {
      var options = {
        video: true,
        audio: true,
      };
      navigator.getUserMedia(options, function (e) {
        console.log("background error : " + e.name);
      });
    }
    dispatch(
      updateAppointmentStatus({
        appId: apntDet?.appointmentId,
        status: "inprogress",
      }),
    );
  };

  const onCloseAdmitModal = (val) => {
    if (val === "Api Success") {
      if (sendToRecovery) {
        dispatch(
          updateAppointmentStatusById({
            appointmentId: apntDet?.appointmentId,
            status: "recovery",
            successMsg: "Status updated successfully!",
          }),
        )?.then((res) => {
          if (res?.payload) getcompliantSummary(apntDet?.appointmentId);
        });
      } else {
        getcompliantSummary(apntDet?.appointmentId);
      }
    }
    setAdmitModVisible(false);
    setSendToRecovery(false);
  };

  const handleDischarge = () => {
    setDisConfrmModVsble(true);
  };

  const handleCoOwnModClose = () => {
    setCoOwnDetails(initCoOwnValues);
    setCoOwnErrors(initCoOwnErrors);
    setCoOwnerModalVisible(false);
  };

  const handleCoOwnChange = (name, value) => {
    setCoOwnDetails({ ...coOwnDetails, [name]: value });
    setCoOwnErrors({ ...coOwnErrors, [name]: value !== "" ? false : true });
  };

  const handleValidation = () => {
    let errs = {};
    Object.keys(coOwnDetails).forEach((det) => {
      if (coOwnDetails?.[det] === "") {
        errs = { ...errs, [det]: true };
      }
    });
    setCoOwnErrors({ ...coOwnErrors, ...errs });
    return Object.keys(errs).length > 0 ? false : true;
  };

  const handleSaveCoOwner = async () => {
    const validated = handleValidation();
    if (!validated) return;
    const data = {
      name: coOwnDetails?.name,
      email: coOwnDetails?.email,
      mobile: coOwnDetails?.mobile,
    };
    dispatch(addCoOwnerByPetId({ petId: petData?.petId, data })).then((res) => {
      if (res?.payload) {
        handleCoOwnModClose();
        if (apntId) {
          getcompliantSummary(apntDet?.appointmentId);
        } else {
          dispatch(getPetDetailsById(petId));
        }
      }
    });
  };

  const handleCloseDisCnfrm = () => {
    setDisConfrmModVsble(false);
  };

  const handleConfirmDischarge = () => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status: "finalize",
        successMsg: "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        handleCloseDisCnfrm();
        getcompliantSummary(apntDet?.appointmentId);
      }
    });
    // dispatch(dischargePatientId(appData?.patientId)).then((res) => {
    //   if (res?.payload) {
    //     navigate("/dashboard");
    //   }
    // });
  };

  const onCloseCreateMod = (e) => {
    if (e === "petCreated") {
      if (apntId) {
        getcompliantSummary(apntDet?.appointmentId);
      } else {
        dispatch(getPetDetailsById(petId));
      }
    }
    setCreatePetModVsble(false);
  };

  const handleChat = () => {
    dispatch(
      createNewChat(apntId ? appData?.pet?.userId : petDetails?.userId),
    ).then((res) => {
      if (res?.payload) {
        navigate("/chat", { state: { chatId: res?.payload?.chatId } });
      }
    });
  };

  const getAllOutstandingBlance = () => {
    return petBilling?.length > 0
      ? petBilling
          ?.filter((li) => (li?.status ?? "")?.toLowerCase() !== "paid")
          ?.reduce(
            (acc, obj) =>
              acc +
              Number(
                Number(
                  Number(
                    getTaxAndSubTotalAndTotal(
                      getTreatmentRecordBasedType(obj?.paymentDetails),
                    )?.subTotal,
                  ) ??
                    0 +
                      Number(
                        getTaxAndSubTotalAndTotal(
                          getPharmacyRecordBasedType(obj?.paymentDetails),
                        )?.subTotal,
                      ) ??
                    0 +
                      Number(
                        getTaxAndSubTotalAndTotal(
                          getPetShopRecordBasedType(obj?.paymentDetails),
                        )?.subTotal,
                      ) ??
                    0,
                ) - Number(obj?.amtPaid ?? 0),
              ),
            //  obj?.balanceDue
            0,
          )
      : 0;
  };

  const handleBundleSelect = () => {
    dispatch(getAllTreatmentBundlesByPetId(petId ?? petDetails?.petId));
    setBundleModVsble(true);
  };

  const handleBundleclose = () => {
    setSelectedBundle(null);
    setBundleModVsble(false);
    setAddNewBundle(false);
    setBundleSearchValue("");
  };

  const handleAddBundle = () => {
    dispatch(getTreatmentBundles());
    setAddNewBundle(true);
  };

  const handleAssign = () => {
    if (
      (selectedBundle?.treatmentId ?? selectedBundle?.bundleId) &&
      (petId ?? petDetails?.petId)
    ) {
      dispatch(
        assignTreatmentBundleToPet({
          treatmentId: selectedBundle?.treatmentId ?? selectedBundle?.bundleId,
          petId: petId ?? petDetails?.petId,
        }),
      ).then((res) => {
        if (res?.payload) {
          handleBundleclose();
        }
      });
    }
  };

  const handleEditPet = () => {
    const reqObj = {
      petId: petData?.petId,
      ageType: "Month",
      dob: getMonthsDifference(petData?.dob),
      petType: null,
      breed: null,
      petName: petData?.petName,
      color: petData?.color,
      gender: petData?.gender,
      reproductiveStatus: petData?.reproductiveStatus,
      weight: petData?.weight,
      rfid: petData?.rfid,
      bloodGroup:
        petData?.bloodGroup?.length > 0
          ? { name: petData?.bloodGroup, value: petData?.bloodGroup }
          : null,
      temperament:
        petData?.temperament?.length > 0
          ? { name: petData?.temperament, value: petData?.temperament }
          : null,
      image: { file: null, previewUrl: petData?.petImage ?? null },
    };
    dispatch(getPetTypes()).then((res) => {
      if (res?.payload) {
        const reqList = res?.payload?.map((sp) => ({
          name: sp?.speciesName,
          value: sp?.speciesName,
          id: sp?.speciesId,
        }));
        reqObj.petType =
          reqList?.find(
            (sp) =>
              (sp?.name ?? "")?.toLowerCase() ===
              (petData?.petType ?? "")?.toLowerCase(),
          ) ?? null;
        setPetTypeList(reqList);
        if (reqObj?.petType?.id) {
          dispatch(getPetBreedsByType(reqObj?.petType?.id)).then((res2) => {
            if (res2?.payload) {
              const reqList = res2?.payload?.map((bd) => ({
                ...bd,
                name: bd?.breedName,
                value: bd?.breedName,
              }));
              reqObj.breed = reqList?.find(
                (bd) =>
                  bd?.value?.toLowerCase() === petData?.breed?.toLowerCase(),
              );
              setBreedList(reqList);
            }
          });
        }
      }
    });

    setPetValues(reqObj);
    setPetModVsble(true);
  };

  const petModClose = () => {
    setPetModVsble(false);
    setPetValues({});
    setErrors({});
  };

  const handleEditUser = () => {
    setUsrValues({
      userName: petData?.userName,
      userMobile: petData?.userMobile,
      address: petData?.address,
      email: petData?.userEmail,
      petId: petData?.petId,
      secondaryMobile: petData?.secondaryMobile ?? "",
    });
    setUsrModVsble(true);
  };

  const usrModClose = () => {
    setUsrModVsble(false);
    setUsrValues({});
    setUsrErrs({});
  };

  const handleValueChange = (value, name) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const valObj = { ...usrValues, [name]: value };
    if (name === "paymentType") {
      valObj.paymentMode = null;
    }
    setUsrValues(valObj);
    const errObj = {
      ...usrErrs,
      [name]:
        reqValue?.length > 0
          ? ""
          : name === "email"
            ? ""
            : "This field is required",
    };

    if (name === "advanceAmount") {
      if (Number(value) <= 0) {
        errObj.advanceAmount = "Amount should be greater than 0";
      } else if (
        Number(value) > Number(petData?.advanceAmount ?? 0) &&
        usrValues?.paymentType === "Refund"
      ) {
        errObj.advanceAmount = "Insufficient credit balance";
      } else {
        errObj.advanceAmount = "";
      }
    }
    setUsrErrs(errObj);
  };

  const onUploadFile = (e) => {
    const reader = new FileReader();
    const file = e?.target?.files[0];
    reader.onloadend = () => {
      setPetValues({
        ...petValues,
        image: { file: e.target.files[0], previewUrl: reader.result },
      });
    };
    reader.readAsDataURL(file);
  };

  const handlePetValueChange = (value, name) => {
    const reqValue =
      typeof value === "object" ? value?.value?.toString() : value;
    const reqObj = { ...petValues, [name]: value };
    if (name === "petType") {
      reqObj.breed = null;
      dispatch(getPetBreedsByType(value?.id)).then((res) => {
        if (res?.payload) {
          const reqList = res?.payload?.map((bd) => ({
            ...bd,
            name: bd?.breedName,
            value: bd?.breedName,
          }));
          setBreedList(reqList);
        }
      });
    }
    setPetValues(reqObj);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]:
        reqValue?.length > 0
          ? ""
          : requiredFields?.includes(name)
            ? "This field is required"
            : "",
    }));
  };

  const validateFields = () => {
    let errObj = {};
    requiredFields?.forEach((key) => {
      const reqValue =
        typeof petValues?.[key] === "object"
          ? petValues?.[key]?.value
          : petValues?.[key];
      if (reqValue?.length === 0 || !reqValue) {
        errObj = { ...errObj, [key]: "This field is required" };
      }
    });
    setErrors({ ...errors, ...errObj });
    return Object.keys(errObj).length > 0;
  };

  const updatePet = () => {
    if (validateFields()) return;
    const form = new FormData();
    if (petData?.ownershipType) {
      form.append("ownershipType", petData?.ownershipType);
    }
    form.append("petName", petValues?.petName);
    form.append("petType", petValues?.petType?.value);
    form.append("breed", petValues?.breed?.value);
    form.append("weight", petValues?.weight);
    form.append("reproductiveStatus", petValues?.reproductiveStatus);
    form.append("gender", petValues?.gender);
    form.append(
      "dob",
      reduceYearsAndMonthsToStartOfMonth({
        years: petValues?.ageType === "Year" ? Number(petValues?.dob) : 0,
        months: petValues?.ageType === "Month" ? Number(petValues?.dob) : 0,
      }),
    );
    form.append("color", petValues?.color);
    if (petValues?.image?.file) form.append("petImage", petValues?.image?.file);
    if (petValues?.rfid?.length > 0) form.append("rfid", petValues?.rfid);
    if (petValues?.bloodGroup?.value?.length > 0)
      form.append("bloodGroup", petValues?.bloodGroup?.value);
    if (petValues?.temperament?.value?.length > 0)
      form.append("temperament", petValues?.temperament?.value);
    dispatch(updatePetById({ petId: petValues?.petId, form })).then((res) => {
      if (res?.payload) {
        if (apntId) {
          getcompliantSummary(apntId);
        } else {
          dispatch(
            getPetDetailsById(petData?.petId ?? petId ?? petValues?.petId),
          );
        }
        petModClose();
      }
    });
  };

  const updateUser = () => {
    if (
      usrValues?.userName?.length === 0 ||
      !usrValues?.userName ||
      usrValues?.userMobile?.length === 0 ||
      !usrValues?.userMobile ||
      !petData?.userId
    ) {
      let errs = { ...usrErrs };
      if (usrValues?.userName?.length === 0 || !usrValues?.userName) {
        errs = { ...errs, userName: "This field is required" };
      }
      if (usrValues?.userMobile?.length === 0 || !usrValues?.userMobile) {
        errs = { ...errs, userMobile: "This field is required" };
      }
      setUsrErrs(errs);
      return;
    }
    const form = new FormData();
    form.append("userName", usrValues?.userName);
    form.append("userMobile", usrValues?.userMobile);
    form.append("advanceAmount", 0);
    if (usrValues?.email?.length > 0) {
      form.append("email", usrValues?.email);
    }
    if (usrValues?.address?.length > 0) {
      form.append("address", usrValues?.address);
    }
    if (usrValues?.secondaryMobile?.length > 0) {
      form.append("secondaryMobile", usrValues?.secondaryMobile);
    }
    dispatch(updateClinicUserById({ userId: petData?.userId, form })).then(
      (res) => {
        if (res?.payload) {
          if (apntId) {
            getcompliantSummary(apntId);
          } else {
            dispatch(
              getPetDetailsById(petData?.petId ?? petId ?? usrValues?.petId),
            );
          }
          usrModClose();
        }
      },
    );
  };

  const handleCollectAdvance = () => {
    setUsrValues({
      paymentType: radioPaymentTypes?.[0]?.value,
      userName: petData?.userName,
      userMobile: petData?.userMobile,
      email: petData?.userEmail,
      petId: petData?.petId,
      paymentMode: UserPaymentTypeList?.[0],
    });
    setAdvancePayModVsble(true);
  };

  const handleClosePayMod = () => {
    setAdvancePayModVsble(false);
    setUsrValues({});
    setUsrErrs({});
  };

  const handlePay = () => {
    if (
      usrValues?.advanceAmount?.length === 0 ||
      !usrValues?.advanceAmount ||
      !usrValues?.paymentMode ||
      (usrValues?.paymentType === "Refund" &&
        Number(usrValues?.advanceAmount) >
          Number(petData?.advanceAmount ?? 0)) ||
      Number(usrValues?.advanceAmount) <= 0
    ) {
      const errs = {};
      if (!usrValues?.paymentMode) errs.paymentMode = "This field is required";
      if (usrValues?.advanceAmount?.length === 0 || !usrValues?.advanceAmount) {
        errs.advanceAmount = "This field is required";
      } else if (usrValues?.advanceAmount <= 0) {
        errs.advanceAmount = "Amount should be greater than 0";
      } else if (
        usrValues?.paymentType === "Refund" &&
        Number(usrValues?.advanceAmount) > Number(petData?.advanceAmount ?? 0)
      ) {
        errs.advanceAmount = "Insufficient credit balance";
      } else {
        errs.advanceAmount = "";
      }
      setUsrErrs(errs);
      if (Object.keys(errs)?.length > 0) return;
    }
    const form = new FormData();
    form.append("userName", usrValues?.userName);
    form.append("userMobile", usrValues?.userMobile);
    if (
      usrValues?.paymentType === "Collect" &&
      petData?.petName &&
      petData?.petId
    ) {
      form.append("petName", petData?.petName);
      form.append("petId", petData?.petId);
    }
    if (usrValues?.email?.length > 0) {
      form.append("email", usrValues?.email);
    }
    if (usrValues?.address?.length > 0) {
      form.append("address", usrValues?.address);
    }
    if (usrValues?.secondaryMobile?.length > 0) {
      form.append("secondaryMobile", usrValues?.secondaryMobile);
    }
    form.append("paymentType", usrValues?.paymentType);
    form.append(
      "advanceAmount",
      Number(
        `${usrValues?.paymentType === "Collect" ? "+" : "-"}${
          usrValues?.advanceAmount
        }`,
      ),
    );
    form.append("paymentMode", usrValues?.paymentMode?.value);
    dispatch(
      updateClinicUserById({
        userId: petData?.userId,
        form,
        successMsg: "Payment updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        if (apntId) {
          getcompliantSummary(apntId);
        } else {
          dispatch(
            getPetDetailsById(petData?.petId ?? petId ?? usrValues?.petId),
          );
        }
        handleClosePayMod();
      }
    });
  };

  const handleClickPet = (pet) => {
    return navigate("/clinic-pet-details", {
      state: {
        appointment: {
          appoinment: {
            appointmentId: pet?.appointmentId ?? null,
            petId: pet?.petId,
          },
        },
        inpatientId: pet?.inpaitentId,
      },
    });
  };

  const handleUploadComplete = async (url, apntId) => {
    await api({ contentType: true, auth: true })
      .get(`/appointment/${apntId}`)
      .then(async (getRes) => {
        if (getRes?.status === 200 || getRes?.status === 201) {
          if (getRes?.data?.data) {
            const reqObj = {
              appointment: {
                ...getRes?.data?.data,
                // caseSummary: url
              },
            };
            try {
              // await superTailsApi.post("/appointment-completed", reqObj);
              setSelectedHistory(null);
            } catch (supErr) {
              console.log("SuperTail Api Error", supErr);
            }
          }
        }
      });
  };

  const onCloseRemMod = () => {
    setRemModVsble(false);
  };

  const onClickAdd = () => {
    setAddVsble(true);
  };

  const onChangeTab = (tab) => {
    setActTab(tab);
    setAddVsble(false);
  };

  const onCloseCertMod = () => {
    setCertModVsble(false);
  };

  const onAssignVetChange = (name, value, errName) => {
    setAssignVetValues({
      ...assignVetvalues,
      [name]: value,
      [errName]: value?.value ? false : true,
    });
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      apntDet?.appointmentType === "Home"
        ? "HomeKit"
        : type === "Surgery"
          ? "OperationTheatre"
          : type === "Consultation" ||
              type === "Lab Tests" ||
              type === "Radiology Tests" ||
              type === "Others"
            ? "ConsultationRoom"
            : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];

    return reqVetList;
  };

  const onAssignVet = () => {
    if (!assignVetvalues?.vet?.value || !assignVetvalues?.facility?.value) {
      return setAssignVetValues({
        ...assignVetvalues,
        error: !assignVetvalues?.vet?.value,
        facilityErr: !assignVetvalues?.facility?.value,
      });
    }
    if (apntDet?.inpatient) {
      updateAppointmentStatusByAppointment({
        status: "insurgery",
        successMsg: "Status updated successfully!",
        isReassign: true,
        facilityId: assignVetvalues?.facility?.value,
        facilityName: assignVetvalues?.facility?.name,
        doctorId: assignVetvalues?.vet?.value,
      });
      return;
    }
    if (apntDet?.appointmentType === "Home") {
      handleInTransitApi(
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name,
      );
    } else {
      handleCallInApi(
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name,
      );
    }
  };

  const updateAppointmentStatusByAppointment = ({
    status,
    isReassign = false,
    successMsg = "Status updated successfully!",
    facilityId = null,
    facilityName = null,
    doctorId = null,
  }) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status,
        successMsg,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (isReassign) {
          const reAssignValues = { facilityId, facilityName, doctorId };
          dispatch(
            clinicReassignAppointment({
              appointmentId: apntDet?.appointmentId,
              data: reAssignValues,
            }),
          )?.then((apiRes) => {
            if (apiRes?.payload) {
              onCloseAssignVetMod();
              getcompliantSummary();
              return;
            }
          });
        } else {
          getcompliantSummary();
        }
      }
    });
  };

  const onClickInpatientBtn = () => {
    if (apntDet?.appointmentStatus === "scheduled") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        updateAppointmentStatusByAppointment({
          status: "insurgery",
          successMsg: "Status updated successfully!",
          isReassign: true,
          facilityId: apntDet?.facilityId,
          facilityName: apntDet?.facility,
          doctorId: reqVet?.doctorId ?? apntDet?.doctorId,
        });
      }
    }
    if (apntDet?.appointmentStatus?.toLowerCase() === "insurgery") {
      setSendToRecovery(true);
      setAdmitModVisible(true);
    }
    if (
      apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
      !appData?.inpatient?.hospitalization
    ) {
      setSendToRecovery(false);
      setAdmitModVisible(true);
    }
    if (
      apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
      appData?.inpatient?.hospitalization
    ) {
      dispatch(
        updateHospitalizationStatus({
          patientId: appData?.inpatient?.patientId,
          status: false,
        }),
      ).then((res) => {
        if (res?.payload) {
          dispatch(
            updateAppointmentStatusById({
              appointmentId: apntDet?.appointmentId,
              status: "scheduled",
              successMsg: "Status updated successfully!",
            }),
          ).then((res2) => {
            if (res2?.payload) {
              getcompliantSummary();
            }
          });
        }
      });
    }
  };

  const isCheckoutDisabled =
    apntDet?.appointmentStatus === "finalize" &&
    ((clinicDetails?.billingMode ?? "")?.toLowerCase() === "separate"
      ? apntDet?.pharmacyCheckout !== "Y" ||
        apntDet?.petShopCheckout !== "Y" ||
        apntDet?.checkOut !== "Y"
      : apntDet?.checkOut !== "Y");

  const onClickSOA = () => {
    setSOAValues({ ...soaValues, visible: true });
  };

  const onCloseSOAMod = () => {
    setSOAValues(initSOAValues);
  };

  const onChangeSOAValue = (name, value) => {
    const reqObj = { ...soaValues, [name]: value };
    setSOAValues(reqObj);
  };

  const onClickProceed = () => {
    const data = { page: 1, itemSize: 100 };
    dispatch(getBillingListByPetId({ petId: petData?.petId, data }));
    setSOAValues({ ...soaValues, dateSelected: true });
  };

  const handlePrint = useReactToPrint({
    content: () => contentToPrint?.current,
    documentTitle: `SOA_${Date.now()}`,
    removeAfterPrint: true,
    pageStyle: a4PrintConfig,
  });

  return (
    <>
      <Grid container className="back-white ph20">
        <Grid
          item
          xs={12}
          sm={12}
          md={2.5}
          lg={2.5}
          xl={2.5}
          className="back-white border-rt"
        >
          <div className="scroll-90vh">
            <Container maxWidth="xl" className="ph20">
              <Typography className="card-head-border-bottom-blue font-bold fs14 capitalize mv5 blue-color mt20">
                Pet Type: {petData?.petType}
              </Typography>
              {petData?.oldPatientId?.length > 0 ? (
                <Typography className="font-bold fs14 red-color mt10">
                  Patient ID: {petData?.oldPatientId?.split(".").shift()}
                </Typography>
              ) : null}
              <Grid container className="mb20 mt10">
                <div className="flex-row-ali-cen">
                  {petData?.petImage ? (
                    <img src={petData?.petImage} alt="" className="img3" />
                  ) : (
                    <div className="flex-center h50img">
                      <Typography className="font-bold fs30 white-color capitalize">
                        {petData?.petName?.[0]}
                      </Typography>
                    </div>
                  )}

                  <div className="flex-column ml10">
                    <div className="flex-row">
                      <div className="flex-center">
                        <Custom3dotString
                          str={petData?.petName}
                          className="font-bold fs14 mv5"
                        />

                        <Typography
                          className={`ml5 font-medium fs14 capitalize card-rose-color ${
                            petData?.gender === "male"
                              ? "card-blue-color"
                              : "card-rose-color"
                          }`}
                        >
                          {`(${petData?.gender})`}
                        </Typography>
                      </div>
                    </div>
                    <Typography className="mb10 txt-regular table-gray fs12">
                      {petData?.breed}
                    </Typography>
                  </div>
                </div>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row">
                    <div className="flex-start">
                      <Typography className="txt-regular gray-color fs12">
                        {moment(
                          petData?.dob ?? location?.state?.pet?.dob,
                        ).fromNow()}{" "}
                        (
                        {moment(
                          petData?.dob ?? location?.state?.pet?.dob,
                        ).format("DD MMM YYYY")}
                        )
                      </Typography>
                    </div>

                    <div className="flex1-end">
                      <img
                        src={require("../../../assets/images/png/weight.png")}
                        alt=""
                        className="img4"
                      />
                      <Typography className="font-bold fs12 ml5">
                        {petData?.weight} KG
                      </Typography>
                    </div>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <Typography className="txt-regular fs12">
                    Reproductive Status : {petData?.reproductiveStatus ?? ""}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <Typography className="txt-regular capitalize fs12">
                    Colour : {petData?.color ?? ""}
                  </Typography>
                </Grid>
                <div className="dashed-card mv20 p20">
                  <div className="flex-row">
                    <AccountCircleOutlinedIcon sx={{ width: 25, height: 25 }} />

                    <Custom3dotString
                      str={petData?.userName}
                      className="font-bold black fs12 ml10 flex-center"
                      length={15}
                    />
                    <div className="flex1-end">
                      <img
                        src={require("../../../assets/images/png/edit2.png")}
                        className="img-wh20 cursor"
                        onClick={handleEditUser}
                      />
                    </div>
                  </div>
                  <div className="flex-row mt10">
                    <MailIcon
                      sx={{
                        color: AppColors.appPrimary,
                        width: 20,
                        height: 20,
                      }}
                    />
                    <div className="flex-center">
                      <Typography className="txt-regular card-gray-color fs12 ml10 ovrflw-wrp-anywre">
                        {petData?.userEmail}
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row mt10">
                    <CallIcon
                      sx={{
                        color: AppColors.appPrimary,
                        width: 20,
                        height: 20,
                      }}
                    />
                    <div className="flex-center">
                      <Typography className="txt-regular card-gray-color fs12 ml10">
                        {petData?.userMobile}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className="flex-row-ali-cen mb10">
                  <div>
                    <CustomButton
                      text="Chat"
                      leftIcon
                      startIcon={<ChatOutlinedIcon />}
                      onClick={handleChat}
                    />
                  </div>
                  {(apntDet?.appointmentStatus === "finalize" ||
                    !apntDet?.inpatient) &&
                    apntId &&
                    (apntDet?.appointmentStatus === "scheduled" ||
                    apntDet?.appointmentStatus === "inprogress" ||
                    // apntDet?.appointmentStatus === "consultation" ||
                    apntDet?.appointmentStatus === "finalize" ||
                    apntDet?.appointmentStatus === "intransit" ||
                    apntDet?.appointmentType === "Virtual" ? (
                      <div className="ml10">
                        <CustomButton
                          text={`${
                            apntDet?.appointmentType === "Virtual" &&
                            apntDet?.appointmentStatus !== "completed"
                              ? "Join Call"
                              : apntDet?.appointmentType === "Physical"
                                ? apntDet?.appointmentStatus === "scheduled"
                                  ? "Check-in"
                                  : apntDet?.appointmentStatus === "inprogress"
                                    ? "Call-in"
                                    : apntDet?.appointmentStatus ===
                                        "consultation"
                                      ? "Finalize"
                                      : "Checkout"
                                : //handled home visit btn
                                  apntDet?.appointmentType === "Home"
                                  ? apntDet?.appointmentStatus === "scheduled"
                                    ? "In Transit"
                                    : apntDet?.appointmentStatus === "intransit"
                                      ? "In Consult"
                                      : apntDet?.appointmentStatus ===
                                          "consultation"
                                        ? "Finalize"
                                        : "Checkout"
                                  : ""
                          }`}
                          onClick={() => {
                            apntDet?.appointmentType === "Virtual"
                              ? handleJoinVideoCall()
                              : apntDet?.appointmentType === "Home"
                                ? callHomeBtnApi()
                                : callButtonApi();
                          }}
                          disabled={isCheckoutDisabled}
                          grayBtn={isCheckoutDisabled}
                          smallBtn
                        />
                      </div>
                    ) : null)}
                  {apntDet?.inpatient &&
                  (apntDet?.appointmentStatus?.toLowerCase() === "scheduled" ||
                    apntDet?.appointmentStatus?.toLowerCase() === "insurgery" ||
                    // (apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
                    //   !appData?.inpatient?.hospitalization) ||
                    (apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
                      appData?.inpatient?.hospitalization)) ? (
                    <div className="ml10">
                      <CustomButton
                        text={`${
                          apntDet?.appointmentStatus?.toLowerCase() ===
                          "scheduled"
                            ? "Call-in"
                            : apntDet?.appointmentStatus?.toLowerCase() ===
                                "insurgery"
                              ? "Send To Recovery"
                              : // : apntDet?.appointmentStatus?.toLowerCase() ===
                                //     "recovery" &&
                                //   !appData?.inpatient?.hospitalization
                                // ? "Admit"
                                apntDet?.appointmentStatus?.toLowerCase() ===
                                    "recovery" &&
                                  appData?.inpatient?.hospitalization
                                ? "Send To Surgery"
                                : ""
                        }`}
                        onClick={() => {
                          onClickInpatientBtn();
                        }}
                        // disabled={
                        //   apntDet?.appointmentStatus === "finalize" &&
                        //   apntDet?.checkOut !== "Y"
                        // }
                        // grayBtn={
                        //   apntDet?.appointmentStatus === "finalize" &&
                        //   apntDet?.checkOut !== "Y"
                        // }
                        smallBtn
                      />
                    </div>
                  ) : null}
                </div>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <Typography className="text-bold mb10 fs14">
                    Shortcuts
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row mv5 cursor">
                    <EditIcon className="lef-icon" />
                    <div className="ml10 flex-center" onClick={handleEditPet}>
                      <Typography className="txt-regular fs14">
                        Edit Profile
                      </Typography>
                    </div>
                  </div>
                </Grid>
                {statusActive ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <CalendarMonthOutlinedIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={bookAppointment}
                        >
                          <Typography className="txt-regular fs14">
                            Book an appointment
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <WorkHistoryIcon className="lef-icon" />
                        <div className="ml10 flex-center" onClick={onClickSOA}>
                          <Typography className="txt-regular fs14">
                            SOA
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <EventAvailableIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={() => setRemModVsble(true)}
                        >
                          <Typography className="txt-regular fs14">
                            Reminders
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <CardMembershipIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={() => setCertModVsble(true)}
                        >
                          <Typography className="txt-regular fs14">
                            Certificates
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </>
                ) : null}
                {/* {!apntDet?.inpatient &&
                  apntDet?.appointmentType === "Virtual" && (
                    <>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="flex-row mv5 cursor">
                          <DescriptionOutlinedIcon className="lef-icon" />
                          <div className="ml10 flex-center">
                            <Typography className="txt-regular fs14">
                              Patient Files
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="flex-row mv5 cursor">
                          <OfflineBoltOutlinedIcon className="lef-icon" />
                          <div className="ml10 flex-center">
                            <Typography className="txt-regular fs14">
                              Send for senior consult
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                    </>
                  )} */}
                {apntDet?.inpatient &&
                appData?.inpatient?.hospitalization &&
                apntDet?.appointmentStatus?.toLowerCase() !== "finalize" &&
                apntDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row mv5 cursor"
                      onClick={handleDischarge}
                    >
                      <BookmarkRemoveIcon className="lef-icon" />
                      <div className="ml10 flex-center">
                        <Typography className="txt-regular fs14">
                          Discharge Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : (apntDet?.inpatient &&
                    !appData?.inpatient?.hospitalization &&
                    apntDet?.appointmentStatus?.toLowerCase() ===
                      "scheduled") ||
                  apntDet?.appointmentType?.toLowerCase() === "virtual" ||
                  apntDet?.appointmentType?.toLowerCase() === "home" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "finalize" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "completed" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "canceled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "cancelled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "pending" ||
                  !apntId ? null : (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row mv5 cursor"
                      onClick={() => setAdmitModVisible(true)}
                    >
                      <MedicationIcon className="lef-icon" />
                      <div className="ml10 flex-center">
                        <Typography className="txt-regular fs14">
                          Admit Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                )}
                {statusActive ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row mv5 cursor">
                      <img
                        src={require("../../../assets/images/png/collectAdvance.png")}
                        className="lef-icon"
                      />
                      <div
                        className="ml10 flex-center"
                        onClick={handleCollectAdvance}
                      >
                        <Typography className="txt-regular fs14">
                          Collect/Refund
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null}
                {/* {apntId ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row mv5 cursor">
                      <BookIcon className="lef-icon" />
                      <div
                        className="ml10 flex-center"
                        onClick={handleBundleSelect}
                      >
                        <Typography className="txt-regular fs14">
                          Select Bundle
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null} */}
              </Grid>
            </Container>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={upcomingVisible ? 7 : 9.5}
          lg={upcomingVisible ? 7 : 9.5}
          xl={upcomingVisible ? 7 : 9.5}
          className={`${upcomingVisible ? "border-rt" : ""} ${
            scrollable ? "scrollable-content" : ""
          }`}
        >
          {/* <Container maxWidth="xl"> */}
          {children}
          {/* </Container> */}
        </Grid>
        {upcomingVisible ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={2.5}
            lg={2.5}
            xl={2.5}
            className="back-white"
          >
            <div className="scroll-90vh">
              <Grid container className="mv20 ph20">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row-between">
                    <Typography className="text-bold mb10 fs14 blue-color">
                      Internal Tags
                    </Typography>
                    {statusActive ? (
                      <img
                        src={
                          petData?.petInternalTags?.length > 0
                            ? EditIconImg
                            : PlusIcon
                        }
                        onClick={openIntrnalTagModal}
                        className="img-wh15 cursor"
                        alt=""
                      />
                    ) : null}
                  </div>
                  {petData?.petInternalTags?.length > 0 && (
                    <div className="flex-row-wrap1 mt10">
                      {petData?.petInternalTags?.map((tg) => (
                        <div
                          className="flex-row-ali-cen pv5 ph10 cursor br5 mh5 mv5"
                          style={{ background: tg?.color }}
                          key={tg?.internalId}
                        >
                          <Typography className="font-bold fs10 white-color">
                            {tg?.tags}
                          </Typography>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="flex-row-between mt10">
                    <Typography className="text-bold mb10 fs14 blue-color">
                      Internal Notes
                    </Typography>
                    {statusActive ? (
                      <img
                        src={
                          // petData?.internalNotes?.[0]?.notes &&
                          // petData?.internalNotes?.[0]?.notes?.length !== 0
                          //   ? EditIconImg
                          //   :
                          PlusIcon
                        }
                        onClick={openIntrnalNotModal}
                        className="img-wh15 cursor"
                        alt=""
                      />
                    ) : null}
                  </div>

                  {/* {petData?.internalNotes?.[0] && (
                    <div className="flex-row-wrap1">
                      <Typography className="ph10 text">
                        {petData?.internalNotes?.[0]?.notes}
                      </Typography>
                    </div>
                  )} */}

                  <Typography className="txt-semi-bold fs14 red-color mt5">
                    Outstanding Balance:{" "}
                    {(Number(getAllOutstandingBlance()) ?? 0 > 0)
                      ? `Rs ${Number(getAllOutstandingBlance()).toFixed(2)}`
                      : "Nil"}
                  </Typography>
                  <Typography className="txt-semi-bold mb20 fs14 green-color mt5">
                    Credits:{" "}
                    {Number(petData?.advanceAmount)
                      ? `Rs ${Number(petData?.advanceAmount).toFixed(2)}`
                      : "Nil"}
                  </Typography>

                  <div className="flex-row-ali-cen">
                    <Typography className="txt-semi-bold fs14 blue-color">
                      App Status:
                    </Typography>

                    <div className="ml20">
                      <CustomButton
                        text={
                          (apntId ? appData?.installed : petDetails?.intsalled)
                            ? "Installed"
                            : "Not Installed"
                        }
                        smallBtn
                      />
                    </div>
                  </div>

                  <div className="flex-row-between mt20">
                    <Typography className="text-bold mb10 fs14 blue-color">
                      Other Pets
                    </Typography>
                    <img
                      src={PlusIcon}
                      alt=""
                      className="img-wh15 cursor"
                      onClick={() => setCreatePetModVsble(true)}
                    />
                  </div>

                  <div className="flex-row scrollx">
                    {(apntId ? appData : petData)?.otherPets?.length > 0 &&
                      (apntId ? appData : petData)?.otherPets
                        ?.filter((pet) => pet?.petId !== petData?.petId)
                        ?.map((pet, i) => (
                          <div
                            key={i + pet?.petId}
                            className="mh10"
                            onClick={() => handleClickPet(pet)}
                          >
                            {pet?.petImage ? (
                              <img
                                src={pet?.petImage}
                                alt=""
                                className="img3"
                              />
                            ) : (
                              <div className="flex-center h50img">
                                <Typography className="font-bold fs30 white-color capitalize">
                                  {pet?.petName?.[0]}
                                </Typography>
                              </div>
                            )}
                            <Custom3dotString
                              str={pet?.petName}
                              className="fs12 mt5 txt-semi-bold flex-center gray4"
                              length={6}
                            />
                          </div>
                        ))}
                  </div>

                  <div className="flex-row-between mt20">
                    <Typography className="text-bold mb10 fs14 blue-color">
                      Co-Owner
                    </Typography>
                    {petData?.coOwners?.length > 0 ? null : (
                      <img
                        src={PlusIcon}
                        alt=""
                        className="img-wh15 cursor"
                        onClick={openCoOwnerModal}
                      />
                    )}
                  </div>

                  <div className="flex-row scrollx">
                    {petData?.coOwners?.length > 0 &&
                      petData?.coOwners?.slice(0, 1)?.map((own, i) => (
                        <div className="dashed-card p20">
                          <div className="flex-row">
                            <AccountCircleOutlinedIcon
                              sx={{ width: 25, height: 25 }}
                            />

                            <Custom3dotString
                              str={own?.name}
                              className="font-bold black fs12 ml10 flex-center"
                              length={15}
                            />
                          </div>
                          <div className="flex-row mt10">
                            <MailIcon
                              sx={{
                                color: AppColors.appPrimary,
                                width: 20,
                                height: 20,
                              }}
                            />
                            <div className="flex-center">
                              <Typography className="txt-regular card-gray-color fs12 ml10 ovrflw-wrp-anywre">
                                {own?.email}
                              </Typography>
                            </div>
                          </div>
                          <div className="flex-row mt10">
                            <CallIcon
                              sx={{
                                color: AppColors.appPrimary,
                                width: 20,
                                height: 20,
                              }}
                            />
                            <div className="flex-center">
                              <Typography className="txt-regular card-gray-color fs12 ml10">
                                {own?.mobile}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        ) : null}
        {modalBookVisible ? (
          <BookAnAppointment
            modalVisible={modalBookVisible}
            setBookModVisible={setBookModVisible}
            selectedPet={selectPet}
          />
        ) : null}
        <InternalTags
          intrnalTagModVsble={intrnalTagModVsble}
          setIntrnalTagModVsble={setIntrnalTagModVsble}
          updatedApp={apntDet}
          appoinment={appointment}
        />
        <InternalNotes
          intrnalNoteModVsble={intrnalNoteModVsble}
          setIntrnalNoteModVsble={setIntrnalNoteModVsble}
          updatedApp={apntDet}
          appoinment={appointment}
        />

        <Allergies
          allergyModOpen={allergyModOpen}
          setAllergyModOpen={setAllergyModOpen}
          updatedApp={apntDet}
          appointment={appointment}
        />
      </Grid>
      {createPetModVsble ? (
        <CreateClinicPet
          createModVisible={createPetModVsble}
          onCloseCreateMod={onCloseCreateMod}
          userDetails={{
            id: apntId ? appData?.pet?.userId : petDetails?.userId,
            email: apntId ? appData?.pet?.userEmail : petDetails?.userEmail,
            name: apntId ? appData?.pet?.userName : petDetails?.userName,
            mobile: apntId ? appData?.pet?.userMobile : petDetails?.userMobile,
          }}
          selectedStep={1}
        />
      ) : null}

      {selectedHistory ? (
        <MedicalHistoryView
          selectedHistory={selectedHistory}
          petData={petData}
          onUploadComplete={(e, apntId) => handleUploadComplete(e, apntId)}
        />
      ) : null}

      <CustomModal
        open={soaValues?.visible}
        onClose={onCloseSOAMod}
        header="SOA"
        modal
        modalWidth={soaValues?.dateSelected ? 80 : 30}
        headerBold
      >
        <div className={`${soaValues?.dateSelected ? "scroll-70vh" : ""} ph20`}>
          <div>
            {!soaValues?.dateSelected ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography className="font-medium fs14 black">
                    Start Date
                  </Typography>
                  <CustomTextField
                    mobileDate
                    fullWidth
                    value={soaValues?.startDate}
                    name="startDate"
                    handleChange={(e) =>
                      onChangeSOAValue("startDate", e?.target?.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography className="font-medium fs14 black">
                    End Date
                  </Typography>
                  <CustomTextField
                    mobileDate
                    fullWidth
                    value={soaValues?.endDate}
                    name="endDate"
                    handleChange={(e) =>
                      onChangeSOAValue("endDate", e?.target?.value)
                    }
                  />
                </Grid>
                <div className="flex1-end mv20">
                  <div>
                    <CustomButton
                      text="Proceed"
                      smallBtn
                      onClick={onClickProceed}
                    />
                  </div>
                </div>
              </Grid>
            ) : null}
            {soaValues?.dateSelected ? (
              <>
                <ContentToPrint
                  ref={contentToPrint}
                  header={
                    <div className="flex-row-ali-cen mv20">
                      <div className="w35Per">
                        <div>
                          {clinicDet?.image ? (
                            <img
                              src={clinicDet?.image}
                              className="img-h75"
                              alt=""
                            />
                          ) : (
                            <div className="flex-center h50img">
                              <Typography className="font-bold fs30 white-color capitalize">
                                {clinicDet?.name?.[0]}
                              </Typography>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="w30Per flex-center">
                        <div className="font-bold fs20 blue-color">SOA</div>
                      </div>
                      <div className="w35Per flex1-end">
                        <div className="prescription-doc-header-clinic">
                          <div className="font-bold blue-color fs16">
                            {clinicDet?.name ?? ""}
                          </div>
                          <div className="txt-regular fs12 blue-color">
                            {clinicDet?.address ?? ""}
                          </div>
                          {clinicDet?.taxId?.length > 0 ? (
                            <div className="flex-row-ali-cen mt5">
                              <div className="font-bold fs12 blue-color">
                                TAX ID:{" "}
                              </div>
                              <div className="txt-regular fs12 blue-color ml3">
                                {clinicDet?.taxId ?? ""}
                              </div>
                            </div>
                          ) : null}
                          {clinicDet?.mobile?.length > 0 ? (
                            <div className="flex-row-ali-cen mt5">
                              <div className="font-bold fs12 blue-color">
                                Contact:{" "}
                              </div>
                              <div className="txt-regular fs12 blue-color ml3">
                                {clinicDet?.mobile ?? ""}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        ;
                      </div>
                    </div>
                  }
                  footer={
                    <div className="prescription-print-footer-inner">
                      {clinicDet?.footer?.length > 0 ? (
                        <img src={clinicDet?.footer} alt="" />
                      ) : null}
                    </div>
                  }
                >
                  <tr>
                    <td className="prescription-print-tbody-cell">
                      <div className="prescription-print-body-inner">
                        {soaValues?.dateSelected ? (
                          <div>
                            <div className="flex-row-ali-cen">
                              <div className="flex-row-ali-cen">
                                <Typography className="font-bold fs14 gray4">
                                  Pet / Parent Name
                                </Typography>
                                <div className="txt-semi-bold fs14 black capitalize ml10">
                                  {petData?.petName} / {petData?.userName}
                                </div>
                              </div>
                              <div className="flex1-end">
                                <div className="flex-row-ali-cen">
                                  <Typography className="font-bold fs14 gray4">
                                    Date Range
                                  </Typography>
                                  <div className="txt-semi-bold fs14 black capitalize ml10">
                                    {moment(
                                      new Date(soaValues?.startDate),
                                    ).format("DD MMM YYYY")}{" "}
                                    -{" "}
                                    {moment(
                                      new Date(soaValues?.endDate),
                                    ).format("DD MMM YYYY")}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="thin-line mt20" />
                            <table className="custom-table">
                              <thead>
                                <tr>
                                  <th className="w20Per">Invoice No.</th>
                                  {/* <th className="w20Per">Invoice/Receipt No.</th> */}
                                  <th className="w10Per">Type</th>
                                  <th className="w10Per">Tr. Date</th>
                                  <th className="w15Per">Total(RS)</th>
                                  <th className="w15Per">Amt Paid</th>
                                  <th className="w15Per">Balance Due</th>
                                  <th className="w15Per">Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(petBillingList?.data ?? [])?.length === 0 ||
                                !petBillingList?.data ? (
                                  <tr>
                                    <td colSpan={5}>
                                      <div className="flex-center">
                                        No records available
                                      </div>
                                    </td>
                                  </tr>
                                ) : null}
                                {(petBillingList?.data ?? [])?.map((bl, i) => {
                                  const comTotal =
                                    (bl?.totalAmt ?? 0) +
                                    (bl?.pharmacyTotalAmt ?? 0) +
                                    (bl?.petShopTotalAmt ?? 0);
                                  const totalAmtPaid =
                                    (bl?.amtPaid ?? 0) +
                                    (bl?.pharmacyAmtPaid ?? 0) +
                                    (bl?.petShopAmtPaid ?? 0);
                                  const totalBalDue =
                                    (bl?.balanceDue ?? 0) +
                                    (bl?.pharmacyBalanceDue ?? 0) +
                                    (bl?.petShopBalanceDue ?? 0);
                                  const payStatus =
                                    Number(comTotal ?? 0) ===
                                    Number(totalAmtPaid ?? 0)
                                      ? "Paid"
                                      : Number(totalAmtPaid ?? 0) > 0
                                        ? "Partially Paid"
                                        : "Unpaid";
                                  const matched = keysToCheck
                                    ?.map((key) => ({ key, value: bl[key] }))
                                    ?.find((item) => item?.value?.length > 0);

                                  return (
                                    <tr key={`${bl?.paymentId}_${i}_tran`}>
                                      <td>{matched?.value ?? ""}</td>
                                      <td>Invoice</td>
                                      <td>
                                        {moment(
                                          new Date(bl?.createdDate),
                                        ).format("DD MMM YYYY")}
                                      </td>
                                      <td>{Number(comTotal)?.toFixed(2)}</td>
                                      <td>
                                        {Number(totalAmtPaid)?.toFixed(2)}
                                      </td>
                                      <td>{Number(totalBalDue)?.toFixed(2)}</td>
                                      <td>
                                        <div className="table-status-row">
                                          <div
                                            className={`capitalize ${
                                              payStatus === "Paid"
                                                ? "table-text-green"
                                                : payStatus === "Unpaid"
                                                  ? "table-text-red"
                                                  : "table-org-txt"
                                            }`}
                                          >
                                            {payStatus}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                            <div className="thin-line" />
                            {(petBillingList?.data ?? [])?.length > 0 ? (
                              <div>
                                <div className="flex1-end ph20 mt10">
                                  <div className="w100Per flex-column">
                                    <div className="flex1-end">
                                      <div className="w40Per">
                                        <div className="flex-row-between-align-center">
                                          <div className="txtstyle">
                                            Grand Total
                                          </div>
                                          <div className="txtstyle">
                                            Rs{" "}
                                            {Number(
                                              getTotalPaidUnpaidForBillings(
                                                petBillingList?.data ?? [],
                                              )?.total,
                                            )?.toFixed(2)}
                                          </div>
                                        </div>
                                        <div className="flex-row-between-align-center">
                                          <div className="txtstyle">
                                            Total Paid
                                          </div>
                                          <div className="txtstyle">
                                            Rs{" "}
                                            {Number(
                                              getTotalPaidUnpaidForBillings(
                                                petBillingList?.data ?? [],
                                              )?.paid,
                                            )?.toFixed(2)}
                                          </div>
                                        </div>
                                        <div className="flex-row-between-align-center">
                                          <div className="txtstyle">
                                            Total Unpaid
                                          </div>
                                          <div className="txtstyle">
                                            Rs{" "}
                                            {Number(
                                              getTotalPaidUnpaidForBillings(
                                                petBillingList?.data ?? [],
                                              )?.unPaid,
                                            )?.toFixed(2)}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                </ContentToPrint>
                <div className="flex-end mv20">
                  <div>
                    <CustomButton text="Print" smallBtn onClick={handlePrint} />
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={remModVsble}
        onClose={onCloseRemMod}
        header="Schedules/Reminders"
        modal
        modalWidth={80}
        headerBold
      >
        <div className="scroll-80vh">
          <div className="flex-row-ali-cen mh20">
            <Typography
              className={`txt-semi-bold fs12 gray4 cursor ${
                actTab === "preventive" ? "tab-grn-back" : "tab-gray-back"
              }`}
              onClick={() => onChangeTab("preventive")}
            >
              Preventive
            </Typography>
            <Typography
              className={`txt-semi-bold fs12 gray4 cursor ml15 ${
                actTab === "prescription" ? "tab-grn-back" : "tab-gray-back"
              }`}
              onClick={() => onChangeTab("prescription")}
            >
              Medications
              {/* Prescription */}
            </Typography>
            <Typography
              className={`txt-semi-bold fs12 gray4 cursor ml15 ${
                actTab === "diagnostics" ? "tab-grn-back" : "tab-gray-back"
              }`}
              onClick={() => onChangeTab("diagnostics")}
            >
              Diagnostics
            </Typography>
            <Typography
              className={`txt-semi-bold fs12 gray4 cursor ml15 ${
                actTab === "procedure" ? "tab-grn-back" : "tab-gray-back"
              }`}
              onClick={() => onChangeTab("procedure")}
            >
              Procedure
            </Typography>
            <div className="flex1-end">
              {actTab === "prescription" ? (
                <div className="w25Per">
                  <Select
                    list={presFilters}
                    value={presFilter}
                    handleChange={(e) => setPresFilter(e?.target?.value)}
                    name="petType"
                    select
                  />
                </div>
              ) : null}
              <div className="ml10">
                <CustomButton text="Add" onClick={onClickAdd} smallBtn />
              </div>
            </div>
          </div>
          {actTab === "preventive" && (
            <ReminderPreventive addVsble={addVsble} setAddVsble={setAddVsble} />
          )}
          {actTab === "prescription" && (
            <ReminderPrescription
              addVsble={addVsble}
              setAddVsble={setAddVsble}
              presFilter={presFilter}
            />
          )}
          {actTab === "diagnostics" && (
            <ReminderDiagnostics
              addVsble={addVsble}
              setAddVsble={setAddVsble}
              apntId={apntId}
            />
          )}
          {actTab === "procedure" && (
            <ReminderProcedure addVsble={addVsble} setAddVsble={setAddVsble} />
          )}
        </div>
      </CustomModal>

      <CustomModal
        open={certModVsble}
        onClose={onCloseCertMod}
        header="Certificates"
        modal
        modalWidth={80}
        headerBold
      >
        <div className="scroll-80vh">
          <div className="flex-row-ali-cen mh20">
            <Typography
              className={`txt-semi-bold fs12 gray4 cursor ${
                actTab === "preventive" ? "tab-grn-back" : "tab-gray-back"
              }`}
              onClick={() => onChangeTab("preventive")}
            >
              Preventive
            </Typography>
          </div>

          <Preventive setScrollable={setScrollable} />
        </div>
      </CustomModal>
      {admitModVisible ? (
        <InpatientAdmitPatient
          modalVisible={admitModVisible}
          onCloseMod={onCloseAdmitModal}
          modalData={{
            ...appData?.appointment,
            patientId: appData?.inpatient?.patientId,
          }}
          sendToRecovery={sendToRecovery}
        />
      ) : null}

      {/* <AdmitPatient
        modalVisible={admitModVisible}
        onCloseMod={onCloseAdmitModal}
        modalData={appData?.appointment}
      /> */}

      <CustomModal
        open={coOwnerModalVisible}
        onClose={handleCoOwnModClose}
        header="Co-Owner Details"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="text-bold fs14 mb5">
              Name <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="name"
              fullWidth
              value={coOwnDetails?.name}
              handleChange={(e) => handleCoOwnChange("name", e?.target?.value)}
              error={coOwnErrors?.name}
              helperText={coOwnErrors?.name ? "Name is required field" : ""}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mb20">
            <div className="text-bold fs14 mb5">
              Email <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="email"
              fullWidth
              value={coOwnDetails?.email}
              handleChange={(e) => handleCoOwnChange("email", e?.target?.value)}
              error={coOwnErrors?.email}
              helperText={coOwnErrors?.email ? "Email is required field" : ""}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mb20">
            <div className="text-bold fs14 mb5 ">
              Contact Number <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="mobile"
              fullWidth
              value={coOwnDetails?.mobile}
              handleChange={(e) =>
                handleCoOwnChange("mobile", e?.target?.value)
              }
              error={coOwnErrors?.mobile}
              helperText={coOwnErrors?.mobile ? "Mobile is required field" : ""}
            />
          </Grid>

          <div className="flex1-end">
            <div>
              <CustomButton text="Save" smallBtn onClick={handleSaveCoOwner} />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={disCofrmModVsble}
        onClose={handleCloseDisCnfrm}
        header="Discharge Pet"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to Discharge the patient?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={handleConfirmDischarge}
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={handleCloseDisCnfrm} />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={bundleModVsble}
        onClose={handleBundleclose}
        header={isAddNewBundle ? "Select Bundle" : "Active Bundle"}
        modal
        modalWidth={40}
        addBtn={!isAddNewBundle}
        onClickAdd={handleAddBundle}
      >
        <div className="scroll-60vh">
          {isAddNewBundle ? (
            <CustomTextField
              placeholder="Search"
              fullWidth
              handleChange={(e) => setBundleSearchValue(e.target.value)}
              value={bundleSearchValue}
              backgroundColor={AppColors.lightPink}
            />
          ) : null}
          {(!isAddNewBundle && petTreatmentBundles?.length > 0) ||
          (isAddNewBundle && treatmentBundles?.length > 0) ? (
            (isAddNewBundle
              ? bundleSearchValue?.length > 0
                ? treatmentBundles?.filter((bl) =>
                    bl?.bundleName
                      ?.toLowerCase()
                      ?.includes(bundleSearchValue?.toLowerCase()),
                  )
                : treatmentBundles
              : petTreatmentBundles
            )?.map((li, i) => (
              <div
                key={i}
                className={`mt10 cursor ${
                  (li?.treatmentId ?? li?.bundleId) ===
                  (selectedBundle?.treatmentId ?? selectedBundle?.bundleId)
                    ? "blue-box2"
                    : "gray-box3"
                }`}
                onClick={() => setSelectedBundle(li)}
              >
                <div className="flex-row-between-align-center">
                  <div className="flex-row-ali-cen">
                    <CustomCheckbox
                      circle
                      checked={
                        selectedBundle
                          ? (li?.treatmentId ?? li?.bundleId) ===
                            (selectedBundle?.treatmentId ??
                              selectedBundle?.bundleId)
                          : false
                      }
                    />
                    <Typography className="fs14 blue-color font-bold">
                      {li?.bundleName}
                    </Typography>
                  </div>
                  <Typography className="font-bold fs14 red12">
                    {!isAddNewBundle
                      ? "Remaining Qty: 1"
                      : `Rs ${Number(
                          getTotalEstimatedCost(li?.treatmentBundleDetails),
                        )?.toFixed(2)}`}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen ph10">
                  <div className="gry-dot2" />
                  <Typography className="fs12 blue-color txt-regular ml5">
                    Type:
                  </Typography>
                  <Typography className="fs12 black20 txt-regular ml5">
                    {li?.usageType}
                  </Typography>
                </div>

                <Typography className="gray22 fs14 font-medium ph10">
                  {li?.description}
                </Typography>
              </div>
            ))
          ) : (
            <div className="no-record">No active bundles available</div>
          )}
          {selectedBundle ? (
            <div className="flex-center">
              <div className="mv20">
                <CustomButton smallBtn text="Assign" onClick={handleAssign} />
              </div>
            </div>
          ) : null}
        </div>
      </CustomModal>

      <CustomModal
        open={petModVsble}
        onClose={petModClose}
        header="Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mb30">
              <CustomUpload
                uploadText="Profile Picture"
                onUploadFile={onUploadFile}
                value={petValues?.image?.previewUrl}
                profileImg
                imageHeight={140}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Name <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <CustomTextField
                  name="petName"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "petName")
                  }
                  value={petValues?.petName}
                  error={!!errors.petName}
                  helperText={errors.petName}
                  label="Name "
                  required={true}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Pet Type <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <Select
                  list={petTypeList}
                  value={petValues?.petType}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "petType")
                  }
                  name="petType"
                  search
                  error={!!errors.petType}
                  helperText={errors.petType}
                  label="Pet Type *"
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Age in {petValues?.ageType} <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <CustomTextField
                  name="dob"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "dob")
                  }
                  value={petValues?.dob}
                  error={!!errors.dob}
                  helperText={errors.dob}
                  label="Age "
                  required={true}
                  type="number"
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Age Type <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <Select
                  list={[
                    { name: "Month", value: "Month" },
                    { name: "Year", value: "Year" },
                  ]}
                  value={petValues?.ageType}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "ageType")
                  }
                  name="ageType"
                  select
                  error={!!errors.ageType}
                  helperText={errors.ageType}
                  label="Age Type * "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Breed <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <Select
                  list={breedList}
                  value={petValues?.breed}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "breed")
                  }
                  name="breed"
                  search
                  error={!!errors.breed}
                  helperText={errors.breed}
                  label="Breed * "
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  label="Color"
                  name="color"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "color")
                  }
                  value={petValues?.color}
                  error={!!errors.color}
                  helperText={errors.color}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Gender
              </div> */}
              <div className="mb20">
                <Select
                  list={genderList}
                  value={petValues?.gender}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "gender")
                  }
                  select
                  error={!!errors.gender}
                  helperText={errors.gender}
                  label="Gender * "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Reproductive Status

              </div> */}
              <div className="mb20">
                <Select
                  list={
                    petValues?.gender?.toLowerCase() === "male"
                      ? reproductiveStatusMaleList
                      : petValues?.gender?.toLowerCase() === "female"
                        ? reproductiveStatusFemaleList
                        : reproductiveStatusUnknownList
                  }
                  value={petValues?.reproductiveStatus}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "reproductiveStatus")
                  }
                  error={!!errors.reproductiveStatus}
                  helperText={errors.reproductiveStatus}
                  select
                  label="Reproductive Status "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  name="weight"
                  value={petValues?.weight}
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "weight")
                  }
                  error={!!errors.weight}
                  helperText={errors.weight}
                  suffix={petValues?.weight !== "" ? "Kg" : ""}
                  label="Weight "
                  // mandatoryField
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  label="Microchip Number"
                  name="rfid"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "rfid")
                  }
                  value={petValues?.rfid}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">Blood Group</div> */}
              <div className="mb20">
                <Select
                  list={bloodGroups}
                  value={petValues?.bloodGroup}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "bloodGroup")
                  }
                  name="bloodGroup"
                  error={!!errors.bloodGroup}
                  helperText={errors.bloodGroup}
                  search
                  label="Blood Group "
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">Temperament</div> */}
              <div className="mb20">
                <Select
                  list={temperaments}
                  value={petValues?.temperament}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "temperament")
                  }
                  name="temperament"
                  label="Temperament"
                  error={!!errors.temperament}
                  helperText={errors.temperament}
                  search
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Update" onClick={updatePet} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={usrModVsble}
        onClose={usrModClose}
        header="Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Parent Name"
                  name="userName"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "userName")
                  }
                  value={usrValues?.userName}
                  error={!!usrErrs.userName}
                  helperText={usrErrs.userName}
                  required={true}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Contact Number"
                  name="userMobile"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "userMobile")
                  }
                  value={usrValues?.userMobile}
                  error={!!usrErrs.userMobile}
                  helperText={usrErrs.userMobile}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Email"
                  name="email"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "email")
                  }
                  value={usrValues?.email}
                  error={!!usrErrs.email}
                  helperText={usrErrs.email}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Secondary Phone Number"
                  name="secondaryMobile"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "secondaryMobile")
                  }
                  value={usrValues?.secondaryMobile}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  label="Address"
                  name="address"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "address")
                  }
                  value={usrValues?.address}
                  labelTop
                  multiline
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Update" onClick={updateUser} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={advancePayVsble}
        onClose={handleClosePayMod}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <div className="flex-center">
          <Card
            sx={{
              borderRadius: 1,
              padding: 2,
              borderTopColor: `${getBorderColor("paid")}`,
            }}
            className="pay-card"
          >
            <div className="maint">
              <div>
                <div className="flex-row parentcontainer">
                  <div className="flex-row  iconcontainer">
                    <AccountCircleOutlinedIcon sx={{ width: 25, height: 25 }} />
                    <Typography className="  font-bold fs14 capitalize flex-center h35">
                      {petData?.userName}
                    </Typography>
                  </div>
                </div>

                <div className="datecontainer"></div>
              </div>
            </div>
          </Card>
        </div>
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14 green-color mt15">
                Available Balance:{" "}
                {Number(petData?.advanceAmount)
                  ? `Rs ${Number(petData?.advanceAmount).toFixed(2)}`
                  : "Nil"}
              </Typography>
              <div className="ml10"></div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14 black mb5">
                Credit Balance:
              </Typography>
              <div className="ml10">
                <CustomCheckbox
                  radio
                  value={usrValues?.paymentType}
                  onChange={(e) =>
                    handleValueChange(e?.target?.value, "paymentType")
                  }
                  radios={radioPaymentTypes}
                  defaultValue={usrValues?.paymentType}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                label="Amount"
                name="advanceAmount"
                fullWidth
                handleChange={(e) =>
                  handleValueChange(e?.target?.value, "advanceAmount")
                }
                value={usrValues?.advanceAmount}
                error={!!usrErrs.advanceAmount}
                helperText={usrErrs.advanceAmount}
                type="number"
              />
            </div>
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            {/* <div className="font-medium fs14 black2">Payment Mode</div> */}
            <div className="mb20">
              {/* <Select
                list={UserPaymentTypeList}
                value={usrValues?.paymentMode}
                handleChange={(e, value) =>
                  handleValueChange(value, "paymentMode")
                }
                name="paymentMode"
                error={!!usrErrs.paymentMode}
                helperText={usrErrs.paymentMode}
                search
                label="Payment Mode"
              /> */}
              <PaymentModeDropdown
                list={UserPaymentTypeList}
                value={usrValues?.paymentMode}
                onChange={(e) => handleValueChange(e, "paymentMode")}
                hideAdvancedAdjustment={
                  usrValues?.paymentType?.toLocaleLowerCase() === "collect"
                }
              />
            </div>
          </Grid>

          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Pay" onClick={handlePay} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={assignVetModVisible}
        onClose={onCloseAssignVetMod}
        header={
          clinicDetails?.id === apntDet?.doctorId &&
          !checkIsVet(profile?.id) &&
          !apntDet?.facilityId
            ? "Select Vet and Facility"
            : !apntDet?.facilityId
              ? "Select Facility"
              : "Select Vet"
        }
        modal
        modalWidth={30}
      >
        <div className="mh10">
          {clinicDetails?.id === apntDet?.doctorId &&
          !checkIsVet(profile?.id) ? (
            <div>
              <Select
                list={
                  apntDet?.serviceType === "Grooming" ||
                  apntDet?.serviceType === "Lab Tests" ||
                  apntDet?.serviceType === "Radiology Tests"
                    ? getOthersByType(apntDet?.serviceType)
                    : apntDet?.serviceType === "Others"
                      ? getAllClinicUserList()
                      : getVetList()
                }
                handleChange={(e, value) =>
                  onAssignVetChange("vet", value, "error")
                }
                name="vet"
                label="Vet Name *"
                search
                value={assignVetvalues?.vet}
                error={!!assignVetvalues?.error}
                helperText={
                  assignVetvalues?.error ? "Vet Name is required field" : ""
                }
              />
            </div>
          ) : null}
          {!apntDet?.facilityId ? (
            <div
              className={
                clinicDetails?.id === apntDet?.doctorId &&
                !checkIsVet(apntDet?.doctorId) &&
                !checkIsVet(profile?.id)
                  ? "mt15"
                  : ""
              }
            >
              <Select
                list={getFacilitiesByType(apntDet?.serviceType)}
                handleChange={(e, value) =>
                  onAssignVetChange("facility", value, "facilityErr")
                }
                name="facility"
                label="Facility *"
                search
                value={assignVetvalues?.facility}
                error={!!assignVetvalues?.facilityErr}
                helperText={
                  assignVetvalues?.facilityErr
                    ? "Facility is required field"
                    : ""
                }
              />
            </div>
          ) : null}
          <div className="flex-center mv20">
            <div>
              <CustomButton text="Save" onClick={onAssignVet} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default CommonClinicPetDetails;
